module.exports = __webpack_public_path__ + "media/images/graphics/gradient-e02ba5775900f470f1d72c8f41492f43.png";